<template>
  <div class="emh-ui-dropdown">
    <wb-select-control :compact="!label">
      <wb-select>
        <label :for="uniqueId">
          {{ label }}
        </label>
        <select :id="uniqueId" v-model="selected" data-test-id="emh-ui-dropdown__select" :disabled="disabled">
          <option v-if="initialValue" selected="selected" :value="undefined">
            {{ initialValue }}
          </option>
          <option
            v-for="(option, idx) in options"
            :key="`${option.label}-${option.value}`"
            class="emh-ui-dropdown__option"
            :value="option.value"
            :disabled="option.disabled"
            :data-test-id="option.key || `emh-ui-dropdown__option-${idx}`"
          >
            {{ option.label }}
          </option>
        </select>
      </wb-select>
      <wb-control-hint v-if="hint">
        {{ hint }}
      </wb-control-hint>
    </wb-select-control>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue';
import { DropdownOption } from './dropdown.modal';

export default defineComponent({
  name: 'UiDropdown',
  props: {
    disabled: Boolean,
    hint: String,
    initialValue: String,
    label: String,
    options: {
      type: Array as PropType<DropdownOption[]>,
      required: true,
    },
    readonly: Boolean,
    value: String,
    required: Boolean,
  },
  emits: ['change'],
  setup(props, { emit }) {
    const uniqueId = ref(window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16));
    const selected = computed({
      get: () => props.value ?? props.options.find((option) => option.selected)?.value,
      set: (newValue) => emit('change', newValue),
    });

    return {
      uniqueId,
      selected,
    };
  },
});
</script>
<style lang="scss">
.emh-ui-dropdown {
  @include wb-spacing('margin-bottom', 'xxs');

  min-height: 76px; // Minimum height to account for possible messages
}
</style>
